// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { PartyCredentialRequirement } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import { OperatorConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Operator';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useModifyOperatorConfiguration: () => UseMutationResult<
  ContractId<OperatorConfiguration>,
  string,
  {
    operatorConfigurationCid: ContractId<OperatorConfiguration>;
    newProviderRequirements: PartyCredentialRequirement[];
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['modifyInstrumentConfiguration', ledgerApi],
    mutationFn: async ({ operatorConfigurationCid, newProviderRequirements }) => {
      return ledgerApi.modifyRegistryOperatorConfiguration(
        operatorConfigurationCid,
        newProviderRequirements,
      );
    },
  });
};

export default useModifyOperatorConfiguration;
